import React, { useContext } from "react";
import _ from "lodash";

import makeStyles from '@mui/styles/makeStyles';
import Typography from "@mui/material/Typography";
import { Button, Card, Container } from "@mui/material";
import Grid from "@mui/material/Grid";

import LanguageContext from "../LanguageContext";
import messages from "../services/messages";
import LiveContentCard from "./LiveContentCard";
import Skeleton from '@mui/material/Skeleton';
import SectionTitle from "./SectionTitle";
import { Help } from "@mui/icons-material";
import UpcomingContentCard from "./UpcomingContentCard";
import UpcomingContentCardHorizontal from "./UpcomingContentCardHorizontal";
import CardContent from "@mui/material/CardContent";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import firebase from "../firebase";

const useStyles = makeStyles((theme) => ({
  root: {
    // display: "flex",
    paddingTop: theme.spacing(4),
  },
  rootNoTopPadding: {
    // display: "flex",
    paddingTop: theme.spacing(2),
  },
  container: {
    // border:'solid',
    // borderWidth:'2px',
    // borderColor:'lightgrey'
  },
  seeAllUpcomingButtonContainer: {
    background: "#FFFFFF",
    border: `solid 1px #E6E4E4`,
    borderRadius: "8px",
    borderTopLeftRadius: `0px`,
    borderTopRightRadius: `0px`,
    marginTop: theme.spacing(-2.2),
  },
  seeAllUpcomingButtonWrapper: {
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(-1),
  },
  seeAllUpcomingButton: {},
  contentCard: {
    marginLeft: theme.spacing(2),
  },
  cropsContainer: {
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    // minHeight: "20vh",
  },
  cropsCardWrapper: {
    flex: "0 0 auto",
  },
  cropThumbnail: {
    width: theme.spacing(8),
    height: theme.spacing(8),
  },

  howToUseMessage: {
    marginTop: theme.spacing(0.8),
    cursor: "pointer",
  },
  helpIcon: {
    height: theme.spacing(2),
    marginBottom: theme.spacing(-0.4),
  },
}));

export default function LiveContentContainer(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);

  return (
    <div
      className={props.noTopPadding ? classes.rootNoTopPadding : classes.root}
    >
      <Container className={classes.container}>
        {/* {!props?.hideTitle && (
          <SectionTitle
            icon={"icons/live.svg"}
            title={messages["dashboard.live.sectionTitle"][language]}
            wideIcon={true}
            userSource={props?.userSource}
          />
        )} */}

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          {_.map(props.liveMeetings, (liveMeeting, index) => {
            return (
              <>
                {(liveMeeting.yt && liveMeeting.page_url) || !liveMeeting.yt ? (
                  <Grid item xs={12} sm={12} md={6} lg={4} key={index}>
                    <LiveContentCard
                      liveMeeting={liveMeeting}
                      position={index + 1}
                      userType={props.userType}
                      farmerCrops={props.farmerCrops}
                      userSource={props?.userSource}
                      userState={props.userState}
                    />
                    {props.showHowToUse === true && (
                      <Typography
                        variant={"body2"}
                        color={"primary"}
                        className={classes.howToUseMessage}
                        onClick={props.handleHowToUse}
                      >
                        <Help className={classes.helpIcon} />
                        {messages["dashboard.howToUse.sectionTitle"][language]}
                      </Typography>
                    )}
                  </Grid>
                ) : (
                  ""
                )}
              </>
            );
          })}

          {props.loading && (
            <>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Skeleton variant="rectangular" height={100} />
              </Grid>
            </>
          )}

          {!props.loading && _.isEmpty(props.liveMeetings) && (
            <>
              {props.allUpcomingMeetings &&
              props.allUpcomingMeetings.length > 0 ? (
                _.map(props.allUpcomingMeetings, (upcomingMeeting, index) => {
                  return (
                    <Grid item xs={12} sm={12} md={6} lg={4} key={index}>
                      <UpcomingContentCardHorizontal
                        upcomingMeeting={upcomingMeeting}
                        userState={props.userState}
                        position={index + 1}
                        userType={props.userType}
                        farmerCrops={props.farmerCrops}
                        userSource={props?.userSource}
                      />
                    </Grid>
                  );
                })
              ) : (
                // <Grid item xs={12} sm={12} md={12}>
                //   <Typography variant={"body2"}>
                //     {props.nextUpcomingTime && props.nextUpcomingTime !== "" && (
                //       <>
                //         {messages["dashboard.live.noSession1"][language]}
                //         {props.nextUpcomingTime}
                //         {messages["dashboard.live.noSession2"][language]}
                //       </>
                //     )}
                //     {props.nextUpcomingTime === "" && (
                //       <>
                //         {messages["dashboard.live.noSession1"][language]}
                //         {
                //           messages["dashboard.live.noSessionNoUpcoming"][
                //             language
                //           ]
                //         }
                //       </>
                //     )}
                //   </Typography>
                // </Grid>
                <></>
              )}
            </>
          )}

          {props.location &&
            props.location === `dashboard` &&
            !props.loading &&
            ((props.liveMeetings && props.liveMeetings.length > 0) ||
              (props.allUpcomingMeetings &&
                props.allUpcomingMeetings.length > 0)) && (
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <div
                  variant={"outlined"}
                  className={classes.seeAllUpcomingButtonContainer}
                >
                  <Button
                    fullWidth={true}
                    variant={"text"}
                    className={classes.seeAllUpcomingButton}
                    color={`primary`}
                    onClick={() => {
                      firebase
                        .analytics()
                        .logEvent("see_all_meetings_clicked", {
                          crop_name: props.upcomingMeeting.crop.name_en,
                          author_name: props.upcomingMeeting.author.name_en,
                          session_topic: props.upcomingMeeting.sessionTopic,
                          start_time: props.upcomingMeeting.startTime,
                          state: props.upcomingMeeting.state.name_en,
                          week: props.upcomingMeeting.week,
                          position: props.position,
                          user_type: props.userType,
                          farmer_crops: JSON.stringify(props.farmerCrops),
                          user_source: props.userSource,
                        });
                    }}
                    href={`/meetings`}
                  >
                    {
                      messages[`dashboard.allClasses.seeAllClassesButton`][
                        language
                      ]
                    }
                    <ArrowForwardIcon />
                  </Button>
                </div>
              </Grid>
            )}
        </Grid>
      </Container>
    </div>
  );
}
